"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNotificationsByThemeAndItemDTO = exports.UpdateNotificationDTO = exports.GetNotificationsDTO = exports.LocalizedNotification = exports.NotificationCreationData = exports.PlaceAttackNotificationData = exports.NotificationData = exports.NotificationListDTO = exports.NotificationDTO = exports.NotificationTypes = exports.NotificationsSubThemes = exports.NotificationThemes = void 0;
const class_validator_1 = require("class-validator");
var NotificationThemes;
(function (NotificationThemes) {
    NotificationThemes["news"] = "news";
    NotificationThemes["place"] = "place";
    NotificationThemes["battle"] = "battle";
    NotificationThemes["friendship"] = "friendship";
})(NotificationThemes = exports.NotificationThemes || (exports.NotificationThemes = {}));
var NotificationsSubThemes;
(function (NotificationsSubThemes) {
    NotificationsSubThemes["welcome"] = "welcome";
    NotificationsSubThemes["place_available"] = "place_available";
    NotificationsSubThemes["place_lost"] = "place_lost";
    NotificationsSubThemes["place_attacked"] = "place_attacked";
    NotificationsSubThemes["place_attack_failed"] = "place_attack_failed";
    NotificationsSubThemes["place_upgraded"] = "place_upgraded";
    NotificationsSubThemes["battle_lost"] = "battle_lost";
    NotificationsSubThemes["battle_won"] = "battle_won";
    NotificationsSubThemes["battle_lost_timeout"] = "battle_lost_timeout";
    NotificationsSubThemes["friendship_received_gift"] = "friendship_received_gift";
})(NotificationsSubThemes = exports.NotificationsSubThemes || (exports.NotificationsSubThemes = {}));
var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["Email"] = "Email";
    NotificationTypes["Push"] = "Push";
    NotificationTypes["InGame"] = "InGame";
})(NotificationTypes = exports.NotificationTypes || (exports.NotificationTypes = {}));
let NotificationDTO = (() => {
    class NotificationDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsEnum(NotificationTypes),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsEnum(NotificationThemes),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "theme", void 0);
    __decorate([
        class_validator_1.IsEnum(NotificationsSubThemes),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "subTheme", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "title", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], NotificationDTO.prototype, "message", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], NotificationDTO.prototype, "seen", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], NotificationDTO.prototype, "finished", void 0);
    __decorate([
        class_validator_1.IsDate(),
        __metadata("design:type", Date)
    ], NotificationDTO.prototype, "createDate", void 0);
    return NotificationDTO;
})();
exports.NotificationDTO = NotificationDTO;
class NotificationListDTO {
}
exports.NotificationListDTO = NotificationListDTO;
let NotificationData = (() => {
    class NotificationData {
    }
    __decorate([
        class_validator_1.IsEnum(NotificationsSubThemes),
        __metadata("design:type", String)
    ], NotificationData.prototype, "subTheme", void 0);
    return NotificationData;
})();
exports.NotificationData = NotificationData;
class PlaceAttackNotificationData extends NotificationData {
}
exports.PlaceAttackNotificationData = PlaceAttackNotificationData;
let NotificationCreationData = (() => {
    class NotificationCreationData {
    }
    __decorate([
        class_validator_1.IsEnum(NotificationThemes),
        __metadata("design:type", String)
    ], NotificationCreationData.prototype, "theme", void 0);
    return NotificationCreationData;
})();
exports.NotificationCreationData = NotificationCreationData;
let LocalizedNotification = (() => {
    class LocalizedNotification {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], LocalizedNotification.prototype, "title", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], LocalizedNotification.prototype, "message", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], LocalizedNotification.prototype, "userId", void 0);
    return LocalizedNotification;
})();
exports.LocalizedNotification = LocalizedNotification;
let GetNotificationsDTO = (() => {
    class GetNotificationsDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetNotificationsDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], GetNotificationsDTO.prototype, "seen", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], GetNotificationsDTO.prototype, "finished", void 0);
    return GetNotificationsDTO;
})();
exports.GetNotificationsDTO = GetNotificationsDTO;
let UpdateNotificationDTO = (() => {
    class UpdateNotificationDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateNotificationDTO.prototype, "notificationId", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpdateNotificationDTO.prototype, "seen", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpdateNotificationDTO.prototype, "finished", void 0);
    return UpdateNotificationDTO;
})();
exports.UpdateNotificationDTO = UpdateNotificationDTO;
let UpdateNotificationsByThemeAndItemDTO = (() => {
    class UpdateNotificationsByThemeAndItemDTO {
    }
    __decorate([
        class_validator_1.IsEnum(NotificationThemes),
        __metadata("design:type", String)
    ], UpdateNotificationsByThemeAndItemDTO.prototype, "theme", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateNotificationsByThemeAndItemDTO.prototype, "itemId", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpdateNotificationsByThemeAndItemDTO.prototype, "seen", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpdateNotificationsByThemeAndItemDTO.prototype, "finished", void 0);
    return UpdateNotificationsByThemeAndItemDTO;
})();
exports.UpdateNotificationsByThemeAndItemDTO = UpdateNotificationsByThemeAndItemDTO;
//# sourceMappingURL=Notifications.js.map